define.alias("ember-math-helpers/helpers/atan2", "settings/helpers/atan2");